import React from 'react';
import { Row, Col, Typography } from 'antd';
import { Area } from '@ant-design/plots';
const { Title } = Typography;

const MetricsChart =  ({ metricsData }) => {
  const configTemplate = {
    title: "",
    data: [],
    xField: (d) => new Date(d.x * 1000),
    yField: (d) => {
      
    },
    height: 200,
    shapeField: 'smooth',
    point: {
      shapeField: 'square',
      sizeField: 2,
      tooltip: false
    },
    interaction: {
      tooltip: {
        marker: false,
      },
    },
    axis: {
      x: {
        grid: true,
        gridLineWidth: 2,
        gridLineDash: [0,0]
      },
      y: {
        title: '',
        style: {
          fontSize: 16,   
          fontWeight: 'bold',
          fill: '#333',
        },
        grid: true,
        gridLineWidth: 2,
        gridLineDash: [0,0]
      },
    },
    style: {
      lineWidth: 1,
      fill: 'l(90) 0:#608EEC 1:#AAC2F4',
    }
  }

  function capitalizeFirstLetter(str) {
    if (!str) return str; // 如果字符串为空或未定义，直接返回
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const getLabel = (metric) => {
    const metricName = metric.metricName;
    let names = metricName.split('/');
    let label = names.map(name => {
      if("cpu" == name) {
        return "CPU";
      } else {
        return capitalizeFirstLetter(name);
      }
    }).join(" ");
    if(metric.device) {
      label += " (" + metric.device + ")";
    }
    return label;
  }

  const getYFunc = (metricName) => {
    if(metricName.indexOf("cpu") != -1) {
      return function(d) {
        return d.y/1000;
      }
    } else if(metricName.indexOf("memory") != -1) {
      return function(d) {
        if(d.y > 1024 * 1024 * 1024) {
          return d.y / 1024 / 1024 /1024;
        } else if(d.y > 1024 * 1024) {
          return d.y / 1024 / 1024;
        } else if(d.y > 1024) {
          return d.y /1024;
        }
      }
    } else if(metricName.indexOf("disk") != -1 || metricName.indexOf("network") != -1) {
      return function(d) {
        return d.y;
      }
    }
  }

  const getTitle = (metricName) => {
    if(metricName.indexOf("cpu") != -1) {
      return "CPU (cores)";
    } else if(metricName.indexOf("memory") != -1) {
      return "Memory (bytes)";
    } else if(metricName.indexOf("disk") != -1) {
      return "Disk ()";
    } else if(metricName.indexOf("network") != -1) {
      return "Network ()";
    }
  }

  const getFillColor = (index) => {
    if(index % 2 == 0) {
      return 'l(90) 0:#608EEC 1:#AAC2F4';
    } else {
      return 'l(90) 0:#36D076 1:#94E8B7';
    }
  }

  const getMergeConfig = (metric, index) => {
    return {
      title: getLabel(metric),
      data: metric.dataPoints,
      yField: getYFunc(metric.metricName),
      axis: {
        y: {
          title: getTitle(metric.metricName)
        }
      },
      style: {
        fill: getFillColor(index)
      }
    };
  }

  const groupedData = metricsData.reduce((acc, value, index) => {
    if (index % 2 === 0) {
      acc.push([{...configTemplate, ...getMergeConfig(value, index)}]);
    } else {
      acc[acc.length - 1].push({...configTemplate, ...getMergeConfig(value, index)});
    }
    return acc;
  }, []);

  return (
    <div>
      {groupedData.map((row, rowIndex) => (
        <Row gutter={40} justify='left' style={{heigh: '200px'}}>
          {row.map((item, itemIndex) => (
            <Col span={12}>
              <Area {...item}/>
            </Col>
          ))}
        </Row>
      ))}
    </div>
  );
};

export default MetricsChart;